/* DekalerSverige theme – vanilla JS, no dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ------------------------------------------------------------------ */
  /* Money                                                               */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || theme.moneyFormat || '{{amount}} kr';

    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision > 0 ? whole + decimal + parts[1] : whole;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */
  function toast(message, type) {
    var region = $('[data-toast-region]');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.textContent = message;
    region.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 3500);
  }

  /* ------------------------------------------------------------------ */
  /* Scroll lock + drawers                                               */
  /* ------------------------------------------------------------------ */
  var locks = 0;
  function lockScroll() {
    if (locks++ === 0) {
      document.documentElement.style.setProperty('--scrollbar-w', (window.innerWidth - document.documentElement.clientWidth) + 'px');
      document.documentElement.classList.add('is-locked');
    }
  }
  function unlockScroll() {
    locks = Math.max(0, locks - 1);
    if (locks === 0) document.documentElement.classList.remove('is-locked');
  }

  var openDrawers = [];
  function openDrawer(el, opener) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    el._opener = opener || document.activeElement;
    lockScroll();
    openDrawers.push(el);
    var panel = $('.drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlockScroll();
    openDrawers = openDrawers.filter(function (d) { return d !== el; });
    if (el._opener && el._opener.focus) el._opener.focus({ preventScroll: true });
    el.dispatchEvent(new CustomEvent('drawer:closed'));
  }
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape' && openDrawers.length) closeDrawer(openDrawers[openDrawers.length - 1]);
  });

  function hiddenHandles() {
    return String(theme.hiddenHandles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  }

  /* ------------------------------------------------------------------ */
  /* Header                                                              */
  /* ------------------------------------------------------------------ */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var root = document.documentElement;

    var setHeight = function () { root.style.setProperty('--header-h', header.offsetHeight + 'px'); };
    setHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(header);

    var main = $('#MainContent');
    var firstSection = main && main.firstElementChild;
    var hero = firstSection && $('[data-hero]', firstSection);
    root.classList.toggle('has-hero', !!hero);

    var lastY = window.scrollY;
    var ticking = false;
    var update = function () {
      var y = window.scrollY;
      var menuOpen = openDrawers.length > 0;
      if (!menuOpen) header.classList.toggle('is-hidden', y > 80 && y > lastY);
      if (hero) {
        var heroBottom = hero.getBoundingClientRect().bottom + y;
        header.classList.toggle('is-over-hero', y < heroBottom - header.offsetHeight - 40);
      }
      lastY = y;
      ticking = false;
    };
    update();
    on(window, 'scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    on(header, 'focusin', function () { header.classList.remove('is-hidden'); });

    // Mobile menu
    var menu = $('[data-mobile-menu]');
    $$('[data-menu-open]').forEach(function (btn) {
      on(btn, 'click', function () { openDrawer(menu, btn); btn.setAttribute('aria-expanded', 'true'); });
    });
    $$('[data-menu-close]', menu || document).forEach(function (btn) {
      on(btn, 'click', function () { closeDrawer(menu); });
    });
    on(menu, 'drawer:closed', function () {
      $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });

    // Mobile search
    var mobileSearch = $('[data-mobile-search]');
    $$('[data-mobile-search-toggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (!mobileSearch) return;
        var show = mobileSearch.hidden;
        mobileSearch.hidden = !show;
        $$('.header__search-btn').forEach(function (b) { b.setAttribute('aria-expanded', String(show)); });
        if (show) { var input = $('[data-search-input]', mobileSearch); if (input) input.focus(); }
      });
    });

    $$('[data-predictive-search]').forEach(initPredictiveSearch);
  }

  function initPredictiveSearch(wrap) {
    var input = $('[data-search-input]', wrap);
    var results = $('[data-search-results]', wrap);
    if (!input || !results || !routes.predictiveSearch) return;
    var timer, controller;

    var close = function () { results.hidden = true; };
    var search = function () {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = $('.search-dropdown', doc);
          results.innerHTML = content ? content.outerHTML : '';
          results.hidden = !content;
        })
        .catch(function (err) { if (err.name !== 'AbortError') close(); });
    };

    on(input, 'input', function () { clearTimeout(timer); timer = setTimeout(search, 180); });
    on(input, 'focus', function () { if (results.innerHTML.trim()) results.hidden = false; });
    on(document, 'click', function (e) { if (!wrap.contains(e.target)) close(); });
    on(wrap, 'keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var links = $$('a', results);
        if (!links.length) return;
        e.preventDefault();
        var i = links.indexOf(document.activeElement);
        i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : Math.max(-1, i - 1);
        (i === -1 ? input : links[i]).focus();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  var Cart = {
    get drawer() { return $('[data-cart-drawer]'); },
    clothShown: false,

    open: function (opener) {
      var d = this.drawer;
      if (!d) { window.location.href = routes.cart; return; }
      this.clothShown = false;
      openDrawer(d, opener);
      this.afterRender();
    },
    close: function () { closeDrawer(this.drawer); },

    request: function (url, body, isForm) {
      var opts = {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      };
      if (!isForm) opts.headers['Content-Type'] = 'application/json';
      var drawer = this.drawer;
      if (drawer) drawer.classList.add('is-busy');
      return fetch(url, opts).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (drawer) drawer.classList.remove('is-busy');
          if (!r.ok) {
            var msg = data.description || data.message || 'Något gick fel. Försök igen.';
            var err = new Error(msg);
            err.status = r.status;
            throw err;
          }
          return data;
        });
      }, function (e) {
        if (drawer) drawer.classList.remove('is-busy');
        throw e;
      });
    },

    render: function (sections) {
      var html = sections && sections['cart-drawer'];
      if (!html) return this.refresh();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-drawer-inner]', doc);
      var current = $('[data-cart-drawer-inner]', this.drawer);
      if (fresh && current) current.replaceWith(fresh);
      this.afterRender();
      return Promise.resolve();
    },

    refresh: function () {
      var self = this;
      var base = routes.root || '/';
      return fetch(base + (base.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) { return self.render(sections); });
    },

    afterRender: function () {
      var inner = $('[data-cart-drawer-inner]', this.drawer);
      if (!inner) return;
      var count = parseInt(inner.getAttribute('data-count'), 10) || 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      // Insurance without anything else in the cart → remove it.
      var orphan = inner.getAttribute('data-orphan-key');
      if (orphan) { this.change(orphan, 0); return; }
      // Cleaning cloth warning, once per opening.
      var dialog = $('[data-cloth-dialog]', inner);
      if (dialog && this.drawer.classList.contains('is-open') && !this.clothShown) {
        this.clothShown = true;
        dialog.hidden = false;
        var ack = $('[data-cloth-ack]', dialog);
        if (ack) ack.focus();
      }
    },

    sectionParams: function () {
      return { sections: 'cart-drawer', sections_url: window.location.pathname };
    },

    change: function (key, quantity) {
      var self = this;
      var body = Object.assign({ id: key, quantity: quantity }, this.sectionParams());
      return this.request(routes.cartChange + '.js', JSON.stringify(body))
        .then(function (data) { return self.render(data.sections); })
        .catch(function (e) { toast(e.message, 'error'); return self.refresh(); });
    },

    addVariant: function (variantId, quantity) {
      var self = this;
      var body = Object.assign({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }, this.sectionParams());
      return this.request(routes.cartAdd + '.js', JSON.stringify(body))
        .then(function (data) { return self.render(data.sections); })
        .catch(function (e) { toast(e.message, 'error'); });
    },

    /** Adds from a FormData (supports line item properties and file uploads). */
    addFormData: function (formData, opener) {
      var self = this;
      var params = this.sectionParams();
      formData.append('sections', params.sections);
      formData.append('sections_url', params.sections_url);
      return this.request(routes.cartAdd + '.js', formData, true).then(function (data) {
        return self.render(data.sections).then(function () { self.open(opener); return data; });
      });
    }
  };

  function initCart() {
    on(document, 'click', function (e) {
      var t = e.target;
      var openBtn = t.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.open(openBtn); return; }
      if (t.closest('[data-cart-close]')) { Cart.close(); return; }

      var qtyBtn = t.closest('[data-qty-change]');
      if (qtyBtn && qtyBtn.closest('[data-cart-drawer]')) {
        var line = qtyBtn.closest('[data-line-key]');
        if (line) Cart.change(line.getAttribute('data-line-key'), parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        return;
      }
      var addBtn = t.closest('[data-add-variant]');
      if (addBtn) {
        addBtn.disabled = true;
        Cart.addVariant(addBtn.getAttribute('data-add-variant'), 1);
        return;
      }
      var pick = t.closest('[data-scraper-pick]');
      if (pick) {
        var colors = $('[data-scraper-colors]', pick.parentNode);
        if (colors) { colors.hidden = false; pick.hidden = true; }
        return;
      }
      var ack = t.closest('[data-cloth-ack]');
      if (ack) { var dlg = ack.closest('[data-cloth-dialog]'); if (dlg) dlg.hidden = true; }
    });

    on(document, 'change', function (e) {
      var box = e.target.closest('[data-insurance-toggle]');
      if (!box) return;
      box.disabled = true;
      if (box.checked) Cart.addVariant(box.getAttribute('data-variant-id'), 1);
      else Cart.change(box.getAttribute('data-line-key'), 0);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Product helpers                                                     */
  /* ------------------------------------------------------------------ */
  /** Normalises `{{ product | json }}` so options always have names + values. */
  function normalizeProduct(p) {
    var opts = p.options || [];
    var names = opts.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var values = names.map(function (_, i) {
      if (opts[i] && opts[i].values) return opts[i].values.slice();
      var seen = [];
      (p.variants || []).forEach(function (v) {
        var val = v.options[i];
        if (seen.indexOf(val) === -1) seen.push(val);
      });
      return seen;
    });
    p.optionNames = names;
    p.optionValues = values;
    return p;
  }

  /** Exact match on all options, otherwise the variant matching the most options. */
  function findVariant(product, selected) {
    var variants = product.variants || [];
    var best = variants[0], bestScore = -1;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], score = 0;
      for (var j = 0; j < selected.length; j++) if (v.options[j] === selected[j]) score++;
      if (score === selected.length) return v;
      if (score > bestScore) { bestScore = score; best = v; }
    }
    return best;
  }

  function initQtySteppers(root) {
    $$('[data-qty-step]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var input = $('input', btn.parentNode);
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, Math.min(99, next));
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Gallery                                                             */
  /* ------------------------------------------------------------------ */
  function Gallery(el) {
    this.el = el;
    this.track = $('[data-gallery-track]', el);
    this.thumbs = $$('[data-thumb]', el);
    this.override = $('[data-gallery-override]', el);
    var self = this;
    this.thumbs.forEach(function (t) {
      on(t, 'click', function () { self.clearOverride(); self.goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var timer;
    on(this.track, 'scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { self.setActive(self.index()); }, 60);
    }, { passive: true });
    on(this.override, 'error', function () { self.clearOverride(); });
  }
  Gallery.prototype.index = function () {
    if (!this.track || !this.track.clientWidth) return 0;
    return Math.round(this.track.scrollLeft / this.track.clientWidth);
  };
  Gallery.prototype.goTo = function (i, instant) {
    if (!this.track) return;
    var slides = this.track.children;
    if (!slides[i]) return;
    this.track.scrollTo({ left: slides[i].offsetLeft - this.track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    this.setActive(i);
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    var slides = $$('[data-media-id]', this.track);
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.goTo(i); return true; }
    }
    return false;
  };
  Gallery.prototype.setActive = function (i) {
    this.thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
  };
  Gallery.prototype.showOverride = function (src, alt) {
    if (!this.override || !src) return this.clearOverride();
    if (this.override.getAttribute('src') !== src) this.override.src = src;
    this.override.alt = alt || '';
    this.override.hidden = false;
    this.el.classList.add('has-override');
  };
  Gallery.prototype.clearOverride = function () {
    if (!this.override) return;
    this.override.hidden = true;
    this.el.classList.remove('has-override');
  };

  /* ------------------------------------------------------------------ */
  /* Product form                                                        */
  /* ------------------------------------------------------------------ */
  function ProductForm(section) {
    var jsonEl = $('[data-product-json]', section);
    var cfgEl = $('[data-product-config]', section);
    if (!jsonEl || !cfgEl) return;
    this.section = section;
    this.product = normalizeProduct(JSON.parse(jsonEl.textContent));
    this.config = JSON.parse(cfgEl.textContent);
    this.form = $('[data-product-form]', section);
    this.variantInput = $('[data-variant-input]', section);
    this.optionEls = $$('[data-option-index]', section);
    this.gallery = new Gallery($('[data-gallery]', section));
    this.feColor = null;
    var ci = this.config.colorIndex;
    this.realColors = ci >= 0 ? this.product.optionValues[ci] : [];

    var self = this;
    this.optionEls.forEach(function (el) { on(el, 'change', function () { self.update(true); }); });

    this.initFeColors();
    this.initSide();
    initQtySteppers(section);
    on(this.form, 'submit', function (e) { e.preventDefault(); self.submit(); });
    this.update(false);
  }

  ProductForm.prototype.selected = function () {
    var sel = [];
    this.optionEls.forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-option-index'), 10);
      if (el.tagName === 'SELECT') sel[idx] = el.value;
      else { var c = $('input:checked', el); sel[idx] = c ? c.value : null; }
    });
    return sel;
  };

  ProductForm.prototype.update = function (userChange) {
    var p = this.product, cfg = this.config;
    var sel = this.selected();
    var eff = sel.slice();
    var ci = cfg.colorIndex;
    var isYellow = ci >= 0 && cfg.yellow && sel[ci] === 'Gul' && this.realColors.indexOf('Gul') === -1;
    if (isYellow) eff[ci] = this.realColors[0];

    var variant = sel.length ? findVariant(p, eff) : (p.variants || [])[0];
    if (!variant) return;
    this.variant = variant;
    this.variantInput.value = variant.id;

    var yellowInput = $('[data-yellow-property]', this.section);
    if (yellowInput) yellowInput.disabled = !isYellow;

    // Price
    var priceEl = $('[data-price-current]', this.section);
    var compareEl = $('[data-price-compare]', this.section);
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareEl.hidden = !hasCompare;
      if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
    }

    // Stock + button
    var dot = $('[data-stock-dot]', this.section);
    var text = $('[data-stock-text]', this.section);
    var btn = $('[data-add-button]', this.section);
    var label = $('[data-add-label]', this.section);
    if (dot) dot.classList.toggle('stock__dot--out', !variant.available);
    if (text) text.textContent = !variant.available ? 'Slut i lager' : (cfg.madeToOrder ? 'Tillverkas vid beställning' : 'Finns i lager');
    if (btn) btn.disabled = !variant.available;
    if (label) label.textContent = variant.available ? 'Köp nu' : 'Slut i lager';

    // URL
    if (userChange && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Image
    var extras = cfg.extras || {};
    var fe = this.feColor && (extras.feColors || []).filter(function (c) { return c.label === this.feColor; }, this)[0];
    var colorKey = ci >= 0 && sel[ci] ? String(sel[ci]).toLowerCase().trim() : null;
    var colorImg = colorKey && extras.colorImages ? extras.colorImages[colorKey] : null;
    if (fe && fe.image) {
      this.gallery.showOverride(fe.image, p.title + ' – ' + fe.label);
    } else if (colorImg) {
      this.gallery.showOverride(colorImg, p.title + ' – ' + sel[ci]);
    } else {
      this.gallery.clearOverride();
      if (userChange && !isYellow && variant.featured_media && !cfg.edition) this.gallery.goToMedia(variant.featured_media.id);
    }
  };

  ProductForm.prototype.initFeColors = function () {
    var list = (this.config.extras || {}).feColors || [];
    var wrap = $('[data-fe-colors]', this.section);
    var holder = $('[data-fe-colors-list]', this.section);
    var input = $('[data-fe-color-property]', this.section);
    if (!list.length || !wrap || !holder || !input) return;
    var self = this;
    var name = 'FeColor-' + this.section.getAttribute('data-section');
    list.forEach(function (c, i) {
      var label = document.createElement('label');
      label.className = 'pill';
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = name;
      radio.value = c.label;
      if (i === 0) radio.checked = true;
      var span = document.createElement('span');
      span.textContent = c.label;
      label.appendChild(radio);
      label.appendChild(span);
      holder.appendChild(label);
      on(radio, 'change', function () {
        self.feColor = c.label;
        input.value = c.label;
        self.update(true);
      });
    });
    this.feColor = list[0].label;
    input.value = list[0].label;
    input.disabled = false;
    wrap.hidden = false;
  };

  ProductForm.prototype.initSide = function () {
    if (!this.config.edition) return;
    var picker = $('[data-side-picker]', this.section);
    var input = $('[data-side-property]', this.section);
    var self = this;
    if (!picker) return;
    var apply = function (instant) {
      var c = $('input:checked', picker);
      var side = c ? c.value : 'Vänster';
      if (input) input.value = side;
      self.gallery.goTo(side === 'Vänster' ? 0 : 1, instant);
    };
    $$('input', picker).forEach(function (r) { on(r, 'change', function () { apply(false); }); });
    apply(true);
  };

  ProductForm.prototype.submit = function () {
    var btn = $('[data-add-button]', this.section);
    if (!this.variant || !this.variant.available) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var fd = new FormData(this.form);
    Cart.addFormData(fd, btn)
      .catch(function (e) { toast(e.message, 'error'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  };

  /* ------------------------------------------------------------------ */
  /* Slideshow + horizontal scrollers                                    */
  /* ------------------------------------------------------------------ */
  function initSlideshow(el) {
    var track = $('[data-slideshow-track]', el);
    var dots = $$('[data-slide-to]', el);
    var slides = $$('[data-slide]', el);
    if (!track || slides.length < 2) return;
    var current = 0, timer = null;
    var delay = (parseInt(el.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var setDots = function (i) {
      current = i;
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
        d.setAttribute('aria-selected', String(idx === i));
      });
    };
    var goTo = function (i) {
      track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
      setDots(i);
    };
    var start = function () {
      stop();
      if (delay && !reduce) timer = setInterval(function () { goTo((current + 1) % slides.length); }, delay);
    };
    var stop = function () { if (timer) clearInterval(timer); timer = null; };

    dots.forEach(function (d) {
      on(d, 'click', function () { goTo(parseInt(d.getAttribute('data-slide-to'), 10)); start(); });
    });
    var t;
    on(track, 'scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { setDots(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
    }, { passive: true });
    on(track, 'pointerdown', start);
    on(document, 'visibilitychange', function () { document.hidden ? stop() : start(); });
    on(el, 'focusin', stop);
    on(el, 'focusout', start);
    start();
  }

  function initScroller(el) {
    var track = $('[data-scroller-track]', el);
    if (!track) return;
    $$('[data-scroll-dir]', el).forEach(function (btn) {
      on(btn, 'click', function () {
        track.scrollBy({ left: parseInt(btn.getAttribute('data-scroll-dir'), 10) * track.clientWidth * 0.6, behavior: 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Collection: load more, sort, back-navigation restore                */
  /* ------------------------------------------------------------------ */
  var GRID_KEY = 'ds-grid-state';

  function initLoadMore(root) {
    $$('[data-load-more]', root).forEach(function (btn) {
      var grid = document.getElementById(btn.getAttribute('data-grid'));
      if (!grid) return;
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        fetch(btn.href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.getElementById(grid.id);
            if (nextGrid) {
              Array.prototype.slice.call(nextGrid.children).forEach(function (c) { grid.appendChild(c); });
            }
            var nextBtn = doc.querySelector('[data-load-more][data-grid="' + grid.id + '"]');
            if (nextBtn) btn.href = nextBtn.href;
            else btn.parentNode.remove();
            grid.setAttribute('data-extended', 'true');
          })
          .catch(function () { window.location.href = btn.href; })
          .then(function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  function saveGridState() {
    var grid = $('[data-product-grid][data-extended]');
    if (!grid) return;
    try {
      var btn = $('[data-load-more][data-grid="' + grid.id + '"]');
      sessionStorage.setItem(GRID_KEY, JSON.stringify({
        url: window.location.href,
        id: grid.id,
        html: grid.innerHTML,
        next: btn ? btn.href : null,
        y: window.scrollY
      }));
    } catch (e) { /* quota – ignore */ }
  }

  function restoreGridState() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var raw;
    try { raw = sessionStorage.getItem(GRID_KEY); } catch (e) { return; }
    if (!raw) return;
    var state;
    try { state = JSON.parse(raw); } catch (e) { return; }
    // Only the listing that saved the state may use (or discard) it.
    if (!state || state.url !== window.location.href) return;
    if (!nav || nav.type !== 'back_forward') { try { sessionStorage.removeItem(GRID_KEY); } catch (e) {} return; }
    var grid = document.getElementById(state.id);
    if (!grid) return;
    grid.innerHTML = state.html;
    grid.setAttribute('data-extended', 'true');
    var btn = $('[data-load-more][data-grid="' + grid.id + '"]');
    if (btn) { if (state.next) btn.href = state.next; else btn.parentNode.remove(); }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    requestAnimationFrame(function () { window.scrollTo(0, state.y); });
  }

  function initSort(root) {
    $$('[data-sort-select]', root).forEach(function (sel) {
      on(sel, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Welcome popup + FAQ chat                                            */
  /* ------------------------------------------------------------------ */
  function store(key, value) {
    try {
      if (value === undefined) return localStorage.getItem(key);
      localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  function initWelcome(root) {
    var modal = $('[data-welcome-popup]', root);
    if (!modal) return;
    var key = modal.getAttribute('data-key') || 'welcome_popup_seen';
    var designMode = window.Shopify && window.Shopify.designMode;
    if (store(key) && !designMode) return;
    var close = function () {
      modal.hidden = true;
      modal.classList.remove('is-open');
      unlockScroll();
      store(key, '1');
    };
    setTimeout(function () {
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      lockScroll();
      var btn = $('.btn', modal);
      if (btn) btn.focus({ preventScroll: true });
    }, designMode ? 0 : (parseInt(modal.getAttribute('data-delay'), 10) || 0) * 1000);
    $$('[data-modal-close]', modal).forEach(function (b) { on(b, 'click', close); });
    on(modal, 'keydown', function (e) { if (e.key === 'Escape') close(); });
    var copy = $('[data-copy]', modal);
    on(copy, 'click', function () {
      var code = copy.getAttribute('data-copy');
      var label = $('[data-copy-label]', copy);
      var done = function () { if (label) label.textContent = 'Kopierad!'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
      else done();
    });
  }

  function initFaqChat(root) {
    var chat = $('[data-faq-chat]', root);
    if (!chat) return;
    var panel = $('[data-faq-panel]', chat);
    var launcher = $('[data-faq-open]', chat);
    var body = $('[data-faq-body]', chat);
    var dot = $('[data-faq-dot]', chat);
    try { if (sessionStorage.getItem('faq-seen')) dot.hidden = true; } catch (e) {}

    var open = function () {
      panel.hidden = false;
      chat.classList.add('is-open');
      launcher.setAttribute('aria-expanded', 'true');
      if (dot) dot.hidden = true;
      try { sessionStorage.setItem('faq-seen', '1'); } catch (e) {}
      if (window.matchMedia('(max-width: 767px)').matches) lockScroll();
    };
    var close = function () {
      panel.hidden = true;
      chat.classList.remove('is-open');
      launcher.setAttribute('aria-expanded', 'false');
      if (window.matchMedia('(max-width: 767px)').matches) unlockScroll();
      launcher.focus();
    };
    on(launcher, 'click', open);
    on($('[data-faq-close]', chat), 'click', close);
    on(panel, 'keydown', function (e) { if (e.key === 'Escape') close(); });

    $$('[data-faq-q]', chat).forEach(function (q) {
      on(q, 'click', function () {
        var tpl = $('template', q);
        var user = document.createElement('div');
        user.className = 'bubble bubble--user';
        user.textContent = q.textContent.trim();
        var bot = document.createElement('div');
        bot.className = 'bubble bubble--bot';
        bot.innerHTML = tpl ? tpl.innerHTML : '';
        body.appendChild(user);
        body.appendChild(bot);
        body.scrollTo({ top: body.scrollHeight, behavior: 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 404: send old (pre-Shopify-theme) URLs to their Shopify equivalents  */
  /* ------------------------------------------------------------------ */
  function legacyRedirect() {
    if (!document.body.classList.contains('template-404')) return;
    var path = window.location.pathname.replace(/\/+$/, '');
    var map = {
      '/dekaler': '/collections/dekaler',
      '/klistermarken': '/collections/klistermarken',
      '/dekalkit': '/collections/dekalkit',
      '/solglasogon': '/collections/solglasogon',
      '/lampor': '/collections/lampor',
      '/tillbehor': '/collections/tillbehor',
      '/mystery-box': '/collections/mystery-box',
      '/epa-dekaler': '/collections/epa-dekaler',
      '/designa': '/pages/designa'
    };
    var target = map[path];
    var m = path.match(/^\/product\/([^/]+)$/);
    if (m) target = '/products/' + m[1];
    if (path === '/dekaler' && window.location.search.indexOf('q=') > -1) {
      target = '/search' + window.location.search + '&type=product';
    }
    if (target) window.location.replace(target);
  }

  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.getAttribute('data-loaded')) return;
      el.setAttribute('data-loaded', '1');
      var load = function () {
        fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = $('[data-recommendations-content]', doc);
          if (content) el.appendChild(content);
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '400px' });
        io.observe(el);
      } else load();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function initSection(root) {
    $$('[data-product-section]', root).forEach(function (s) { new ProductForm(s); });
    $$('[data-slideshow]', root).forEach(initSlideshow);
    $$('[data-scroller]', root).forEach(initScroller);
    initLoadMore(root);
    initSort(root);
    initWelcome(root);
    initFaqChat(root);
    initRecommendations(root);
  }

  window.Theme = {
    Cart: Cart,
    toast: toast,
    formatMoney: formatMoney,
    normalizeProduct: normalizeProduct,
    findVariant: findVariant,
    initQtySteppers: initQtySteppers
  };

  legacyRedirect();
  initHeader();
  initCart();
  restoreGridState();
  initSection(document);
  on(window, 'pagehide', saveGridState);

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var modal = $('[data-welcome-popup]', e.target);
    if (modal) { modal.hidden = false; modal.classList.add('is-open'); }
  });
  document.dispatchEvent(new CustomEvent('theme:ready'));
})();
